import React from 'react';
import { Button } from 'rmwc/Button';
import gtagEvent from '../../utilities/analytics/gtag-event';

import './landing-pages.css';
import '@material/button/dist/mdc.button.min.css';

const heroUri = 'https://firebasestorage.googleapis.com/v0/b/quiver-four.appspot.com/o/marketing%2F640%2FDSC03464.JPG?alt=media&token=2d175a1d-dc7d-4c95-9f3a-47783d60a655';

export default props => {
  return (
    <article id="modern-calligraphy-kit-description" className="static-landing-page" role="main">
      <section className="centered">
        <div className="row">
          <div className="hide-small background">
            <img className="hero" src={heroUri} alt="modern calligraphy kit" />
          </div>
          <div className="flex">
            <h1 className="headline-text">Modern Calligraphy Kit</h1>
            <p className="primary-text">Quick and easy</p>
            <p className="secondary-text">
              <strong>Supplies questions?</strong> <br /> Check out our{' '}
              <a href="/public/calligraphy-supplies-guide">Calligraphy Supplies Guide</a> for all of
              the details.
            </p>
            <a href="https://store.calligraphy.org/collections/calligraphy-kits">
              <Button
                className="cta-button"
                raised
                onClick={() =>
                  gtagEvent('cta-click', {
                    page: 'modern-calligraphy-kit-description',
                    position: 'primary',
                  })
                }
              >
                Shop our kits
              </Button>
            </a>
          </div>
        </div>
      </section>
    </article>
  );
};
